import { render, staticRenderFns } from "./ImsProfitLossAssignTrader.vue?vue&type=template&id=3376a8ea&"
import script from "./ImsProfitLossAssignTrader.vue?vue&type=script&lang=js&"
export * from "./ImsProfitLossAssignTrader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports